import script from "./video-upload.vue?vue&type=script&setup=true&lang=js"
export * from "./video-upload.vue?vue&type=script&setup=true&lang=js"

import "./video-upload.vue?vue&type=style&index=0&id=8f79ae24&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f79ae24"]])

export default __exports__